import { useEffect } from 'react';
import { useToken } from './store';
import logger from './logger';
import { ErrorFallback, logError } from './Auth';
import { ErrorBoundary } from 'react-error-boundary';
import App from './App';

export const ParentAuth = () => {
  const [tkn, setToken] = useToken();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const authToken = params.get('authToken');
    if (authToken) {
      logger.info('Found authToken in URL, logging in');
      // Clear the logout flag to allow new authentication
      localStorage.removeItem('userLoggedOut');
      localStorage.setItem('loginTime', String(Date.now()));
      setToken(authToken);
      // Remove authToken from URL
      params.delete('authToken');
      const newUrl =
        window.location.pathname +
        (params.toString() ? '?' + params.toString() : '');
      try {
        window.history.replaceState({}, document.title, newUrl);
      } catch (error) {
        logger.error('Error replacing history state', { error });
      }
    } else if (!tkn) {
      window.location.href = '/';
    }
  }, [setToken, tkn]);

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={logError}>
      {tkn && <App />}
    </ErrorBoundary>
  );
};
